import React from 'react';

import Fintalk from "./assets/img/clients/Fintalk-Logo.png";
import FreshFarm from "./assets/img/clients/FreshFarmLogo.jpg";
import FoodTech from "./assets/img/clients/foodtechlogo.png";
import Aristone from "./assets/img/clients/ariston_engineers_logo.png";
import Trradex from "./assets/img/clients/Trradex_Capital_logo.jpg";
import Flashcode from "./assets/img/clients/Flashcodelogo.png";




import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';


const Portfolio = () => {
    return(
<section id="portfolio" class="portfolio">
      <div class="container">

        <div class="section-title" data-aos="">
          <h2>Portfolio</h2>
          <p></p>
        </div>

        <div class="row">
          <div class="col-lg-12 d-flex justify-content-center" data-aos="" data-aos-delay="100">
            <ul id="portfolio-flters">
              <li data-filter="*" class="filter-active">All</li>
              <li data-filter=".filter-app">Web Application</li>
              <li data-filter=".filter-card">Mobile Application</li>
              <li data-filter=".filter-web">Website Design</li>
            </ul>
          </div>
        </div>

        <div class="row portfolio-container" data-aos="" data-aos-delay="200">

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
              <img src={Trradex} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>Trradex Capital</h4>
                <p>Website</p>
              </div>
              <div class="portfolio-links">
                <a href={Trradex} data-gallery="portfolioGallery" class="portfolio-lightbox" title="App 1"><i class="bx bx-plus"></i></a>
                <a href="http://www.trradex.com/" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
              <img src={Fintalk} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>Fintalk Services</h4>
                <p>Website</p>
              </div>
              <div class="portfolio-links">
                <a href={Fintalk} data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web 3"><i class="bx bx-plus"></i></a>
                <a href="http://www.fintalk.in/" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
              <img src={Aristone} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>Aristone BIM service LLP</h4>
                <p>Website</p>
              </div>
              <div class="portfolio-links">
                <a href={Aristone} data-gallery="portfolioGallery" class="portfolio-lightbox" title="App 2"><i class="bx bx-plus"></i></a>
                <a href="https://aristonengineers.com/" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
              <img src={FoodTech} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>ASSPM, Sangulwadi</h4>
                <p>Webiste</p>
              </div>
              <div class="portfolio-links">
                <a href={FoodTech} data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 2"><i class="bx bx-plus"></i></a>
                <a href="http://www.asspm.in/" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-app">
            <div class="portfolio-wrap">
              <img src={FreshFarm} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>FreshFarm </h4>
                <p>Mobile App</p>
              </div>
              <div class="portfolio-links">
                <a href={FreshFarm} data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web 2"><i class="bx bx-plus"></i></a>
                <a href="#" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-app">
            <div class="portfolio-wrap">
              <img src={Flashcode} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>Flashcode </h4>
                <p>Web Application for sale </p>
              </div>
              <div class="portfolio-links">
                <a href={Flashcode} data-gallery="portfolioGallery" class="portfolio-lightbox" title="App 3"><i class="bx bx-plus"></i></a>
                <a href="#" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>
{/* 
          <div class="col-lg-4 col-md-6 portfolio-item filter-card">
            <div class="portfolio-wrap">
              <img src={P7} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>Card 1</h4>
                <p>Card</p>
              </div>
              <div class="portfolio-links">
                <a href="assets/img/portfolio/portfolio-7.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 1"><i class="bx bx-plus"></i></a>
                <a href="portfolio-details.html" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-card">
            <div class="portfolio-wrap">
              <img src={P8} class="img-fluid" alt=""/>
              <div class="portfolio-info">
                <h4>Card 3</h4>
                <p>Card</p>
              </div>
              <div class="portfolio-links">
                <a href="assets/img/portfolio/portfolio-8.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 3"><i class="bx bx-plus"></i></a>
                <a href="portfolio-details.html" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
              <img src={P9} class="img-fluid" alt="" />
              <div class="portfolio-info">
                <h4>Web 3</h4>
                <p>Web</p>
              </div>
              <div class="portfolio-links">
                <a href="assets/img/portfolio/portfolio-9.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web 3"><i class="bx bx-plus"></i></a>
                <a href="portfolio-details.html" title="More Details"><i class="bx bx-link"></i></a>
              </div>
            </div>
          </div> */}

        </div>

      </div>
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<ins class="adsbygoogle"
    //  style="display:block"
     data-ad-format="fluid"
     data-ad-layout-key="-fb+5w+4e-db+86"
     data-ad-client="ca-pub-1937777226188556"
     data-ad-slot="6956732655"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
</script>
    </section>
    )
}




export default Portfolio;